// video.ts

export async function configureScene(src: string): Promise<Media | null> {
    try {
        const resolvedSrc = resolveMediaURL(src);
        const response = await fetch(resolvedSrc, { cache: "force-cache" });
        const blob = await response.blob();
        const buffer = await blob.arrayBuffer();
        return {
            data: buffer,
            contentType: response.headers.get("Content-Type") || "video/mp4",
            name: src,
            shouldPlayImmediately: true,
            shouldLoop: true,
        };
    } catch (error) {
        console.error("Error fetching video:", src, error);
        return null;
    }
}

export function mseIsSupported() {
    return "MediaSource" in window;
}

export const NEXT_VIDEO_THRESHOLD = 0.5;

export type Media = {
    shouldPlayImmediately?: boolean;
    shouldLoop?: boolean;
    data: ArrayBuffer;
    name: string;
    contentType: string;
    navigateAfter?: string;
};

export function resolveMediaURL(url: string): string {
    // Simple local asset path — adjust if needed
    return `/videos/${url}`;
}
